import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC8nDdrQEIieKtzDQ2Tj5_-seFy-MG95V4",
  authDomain: "blue-star-438017.firebaseapp.com",
  projectId: "blue-star-438017",
  storageBucket: "blue-star-438017.appspot.com",
  messagingSenderId: "326774906941",
  appId: "1:326774906941:web:e8678216226c14a5804a54"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);